import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button, Container, FloatingLabel } from "react-bootstrap";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

function Edit_data_entry() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data_heading, setData_heading] = useState("");
  const [data_details, setData_details] = useState("");
  const [comment, setComment] = useState("");

  const [documents, setDocuments] = useState([
    { id: Date.now(), name: "", file: null, doc_id: null, doc_path: "", deleted: false }
  ]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    axios
      .get(`${API_URL}/data_entry_id_wise/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        const data = res.data.data_entry;
        setData_heading(data.data_heading);
        setData_details(data.data_details || "");
        setComment(data.comment || "");

        setDocuments(
          data.documents?.length
            ? data.documents.map(doc => ({
              id: Date.now() + Math.random(),
              name: doc.doc_name,
              file: null,
              doc_path: doc.doc_path,
              doc_id: doc.doc_id,
              deleted: false
            }))
            : [{ id: Date.now(), name: "", file: null, doc_id: null, deleted: false }]
        );
      })
      .catch(err => console.error(err));
  }, [id]);

  const addRow = () => {
    setDocuments([...documents, { id: Date.now(), name: "", file: null, doc_id: null, deleted: false }]);
  };

  const removeRow = (docId) => {
    setDocuments(prevDocuments =>
      prevDocuments.map(doc =>
        doc.id === docId ? { ...doc, deleted: true } : doc
      )
    );
  };

  const handleNameChange = (docId, value) => {
    setDocuments(prevDocuments =>
      prevDocuments.map(doc =>
        doc.id === docId ? { ...doc, name: value } : doc
      )
    );
  };

  const handleFileChange = (docId, file) => {
    setDocuments(prevDocuments =>
      prevDocuments.map(doc =>
        doc.id === docId ? { ...doc, file } : doc
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("data_heading", data_heading);
    formData.append("data_details", data_details);
    formData.append("comment", comment);


    documents.forEach((doc, index) => {
      if (!doc.deleted) {
        formData.append(`document_name[${index}]`, doc.name);
        formData.append(`doc_id[${index}]`, doc.doc_id || "");

        if (doc.file) {
          formData.append(`document_file[${index}]`, doc.file);
        }
      } else {
        formData.append(`deleted_doc_id[${index}]`, doc.doc_id);
      }
    });

    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(`${API_URL}/data_entry_update/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      });

      alert(res.data.message);
      navigate("/List_data_entry");
    } catch (err) {
      console.error(err);
      alert("Error updating data entry!");
    }
  };

  return (
    <Container className="mt-4">

      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
        <h3 className="mb-2 mb-md-0">Edit Data Entry</h3>

        <div className="d-flex gap-2">
          <Link className="btn btn-sm btn-primary" to="/data-entry">Add New Data</Link>
          <Link className="btn btn-sm btn-primary" to="/List_data_entry">List</Link>
        </div>
      </div>

      <Form onSubmit={handleSubmit} autoComplete="off">

        <Row className="gy-3">

          <Col xs={12}>
            <FloatingLabel controlId="floatingHeading" label="Enter Heading">
              <Form.Control
                type="text"
                value={data_heading}
                onChange={(e) => setData_heading(e.target.value)}
                style={{ backgroundColor: "#d6f5f5" }}
                placeholder="Enter heading"
              />
            </FloatingLabel>
          </Col>

          <Col xs={12}>
            <FloatingLabel controlId="floatingDetails" label="Enter Details">
              <Form.Control
                as="textarea"
                value={data_details}
                onChange={(e) => setData_details(e.target.value)}
                style={{ height: "100px", backgroundColor: "#99e6e6" }}
                placeholder="Enter details"
              />
            </FloatingLabel>
          </Col>

          <Col xs={12}>
            <FloatingLabel controlId="floatingComment" label="Enter Comments">
              <Form.Control
                as="textarea"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{ height: "60px" }}
                placeholder="Enter comments"
              />
            </FloatingLabel>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col xs={12}>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr style={{ backgroundColor: "#e6ffff", fontWeight: "bold" }}>
                    <th>Sr.No</th>
                    <th>Document Name</th>
                    <th>Select Document</th>
                    <th>
                      <i
                        className="bi bi-plus"
                        style={{ cursor: "pointer", fontSize: "1.2rem" }}
                        onClick={addRow}
                      ></i>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {documents.map((doc, index) =>
                    !doc.deleted ? (
                      <tr key={doc.id}>
                        <td>{index + 1}</td>

                        <td>
                          <Form.Control
                            type="text"
                            name={`document_name[${index}]`}
                            value={doc.name}
                            onChange={(e) => handleNameChange(doc.id, e.target.value)}
                            placeholder="Enter document name"
                          />
                          <input type="hidden" name={`doc_id[${index}]`} value={doc.doc_id || ""} />
                        </td>

                        <td>
                          <Form.Control
                            type="file"
                            name={`document_file[${index}]`}
                            accept=".jpg,.jpeg,.png,.pdf,.svg"
                            onChange={(e) => handleFileChange(doc.id, e.target.files[0])}
                          />

                          {doc.doc_path && (
                            <a
                              href={`${API_URL}/documents/${doc.doc_id}/${doc.doc_path}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              View File
                            </a>
                          )}
                        </td>

                        <td>
                          <i
                            className="bi bi-trash"
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() => removeRow(doc.id)}
                          ></i>
                        </td>
                      </tr>
                    ) : null
                  )}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs={12} className="d-flex justify-content-center">
            <Button variant="primary" type="submit">
              Update
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );

}

export default Edit_data_entry;
